/* Croatian fallback for English accessible labels in the legacy Judge.me widget.
 * Exact known labels only: customer review text and vendor handlers stay owned
 * by Judge.me. Observe widget roots, never the document or unrelated app UI.
 */
(() => {
  if (!/^hr(?:-|$)/i.test(document.documentElement.lang)) return;
  const observed = new WeakSet();
  const fixed = new Map([
    [
      "Choose a review picture/video (optional)",
      "Odaberite fotografiju ili video za recenziju (neobavezno)",
    ],
    ["Name format", "Način prikaza imena"],
  ]);
  const localNumber = (value) => value.replace(".", ",");
  const reviewNoun = (count) => {
    const lastTwo = Number(count) % 100;
    const last = Number(count) % 10;
    if (last === 1 && lastTwo !== 11) return "recenzija";
    if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14))
      return "recenzije";
    return "recenzija";
  };

  function translatedLabel(node, label) {
    if (fixed.has(label)) return fixed.get(label);
    let match = /^Average rating is (\d+(?:\.\d+)?) stars$/.exec(label);
    if (match && Number(match[1]) <= 5)
      return `Prosječna ocjena: ${localNumber(match[1])} od 5`;
    match =
      /^(\d+(?:\.\d+)?)% \((\d+)\) reviews with ([1-5]) star rating$/.exec(
        label,
      );
    if (match && Number(match[1]) <= 100) {
      return `Ocjena ${match[3]} od 5: ${match[2]} ${reviewNoun(match[2])} (${localNumber(match[1])}%)`;
    }
    match = /^([1-5]) star review$/.exec(label);
    if (match) return `Ocjena recenzije: ${match[1]} od 5`;
    match = /^([1-5]) stars?$/.exec(label);
    if (match) return `${match[1]} od 5 zvjezdica`;
    match = /^Page ([1-9]\d*)$/.exec(label);
    if (match) {
      const directions = [
        ["next-page", "Sljedeća stranica"],
        ["last-page", "Posljednja stranica"],
        ["prev-page", "Prethodna stranica"],
        ["first-page", "Prva stranica"],
      ];
      const direction = directions.find(([name]) =>
        node.classList.contains(`jdgm-paginate__${name}`),
      );
      return direction
        ? `${direction[1]}: ${match[1]}`
        : `Stranica ${match[1]}`;
    }
    return label;
  }

  function localize(root) {
    root.querySelectorAll("[aria-label]").forEach((node) => {
      const original = node.getAttribute("aria-label");
      const translated = translatedLabel(node, original);
      if (original !== translated) node.setAttribute("aria-label", translated);
    });
    root.querySelectorAll(".jdgm-sort-dropdown-label").forEach((node) => {
      if (node.textContent.trim() === "Sort by")
        node.textContent = "Poredaj recenzije";
    });
  }

  function initialize() {
    document.querySelectorAll(".jdgm-review-widget").forEach((root) => {
      if (observed.has(root)) return;
      observed.add(root);
      localize(root);
      new MutationObserver(() => localize(root)).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["aria-label"],
      });
    });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
  document.addEventListener("shopify:section:load", initialize);
})();
